import api from './api'
import { BASE } from './config'

import { DEFAULT_PAGINATION_LIMIT } from '../constants/common'

class NotificationsService {
  getUnredNotificationsCount() {
    return api.get(`${BASE}/events/notifications/unread/`)
  }

  getNotificationList(params) {
    return api.get(`${BASE}/events/notifications/`, {
      params: { ...params, limit: DEFAULT_PAGINATION_LIMIT },
    })
  }

  markNotificationsAsRead(data) {
    return api.post(`${BASE}/events/notifications/mark_as_read/`, data)
  }
}

export default new NotificationsService()
